import type { CurrentUserSearchConfig } from "./types"
import type { NextRequest } from "@/modules/fetch/types"
import type { I18nLocale } from "@/modules/i18n/types"

import { getResultFromResponse } from "@/modules/apiRequests/handlers"
import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"
import { DEFAULT_STORAGE_DURATION } from "@/modules/serverStorage/constants"

import { CURRENT_USER_SEARCH_CONFIG_ENDPOINT, CURRENT_USER_SEARCH_CONFIG_QUERY_KEY } from "./constants"

type GetCurrentUserSearchConfigParams = {
  locale: I18nLocale
  req?: NextRequest
}

export const getCurrentUserSearchConfig = async (
  params: GetCurrentUserSearchConfigParams
): Promise<CurrentUserSearchConfig> => {
  const { locale, req } = params

  return fetcher(CURRENT_USER_SEARCH_CONFIG_ENDPOINT, {
    nextRequest: req,
    requestInit: {
      headers: {
        "Accept-Language": locale,
      },
    },
    serviceDomain: "KRAKEND_API",
    storageDuration: DEFAULT_STORAGE_DURATION,
    storageKey: `${CURRENT_USER_SEARCH_CONFIG_QUERY_KEY}::${locale}`,
  })
    .then(getResultFromResponse<CurrentUserSearchConfig>())
    .catch(handleFetchError(CURRENT_USER_SEARCH_CONFIG_ENDPOINT))
}
